import React, { Fragment } from 'react';
import { Calendar } from 'primereact/calendar';
import { addLocale } from "primereact/api";
import './StyleSelf.css'
import { ConfigServer } from "../../data/config";
import { useMicrositeSelfBillings } from '../../hooks/selfBilling/useMicrositeSelfBillings'
import { Toast } from "primereact/toast";
import { Button } from 'primereact/button';
import { Col } from 'reactstrap'



export const SelfBilling = () => {
    const {
        // ? FORM BILING
        formSelfBiling,

        // * STEP 1
        step,
        showPassword,
        setShowPassword,
        handleChangeForm,
        parseDate,
        saveStep1,
        validations,
        loadingValidation,
        loadingText,


        // * STEP 2
        listTaxRegimes,
        handleChangeInputEditPatient,
        validationsPatient,
        verifyData,
        toastBC,
        showTicketAlert,
        ticketMessage,
        setShowTicketAlert,
        showSuccessAlert,
        loadingInvoice,
        loadingInvoiceText,
        listUseCFDI,

        // * STEP 3
        tittlePdf,
        handleDownloadInvoice,
        showDownloadAlert,
        loadingDownload,
        loadingXml,
        handleDownloadXml,
        isStampInvoice,
        resetInvoiceFlow


    } = useMicrositeSelfBillings();


    // * CONFIGURATION LOCAL CALENDER
    addLocale("es", {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
        monthNames: [
            "enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ],
        monthNamesShort: [
            "ene", "feb", "mar", "abr", "may", "jun",
            "jul", "ago", "sep", "oct", "nov", "dic"
        ],
        today: "Hoy",
        clear: "Limpiar"
    });





    return (
        <div className='' >
            <Toast
                ref={toastBC}
                position="top-right"
                baseZIndex={999999}
                className='pt-4'
            />
            <div className="Ivs2">

                {/* ==========================
                     HEADER
                  ========================== */}

                <header className="Ivs2-top-bar">

                </header>

                {/* ==========================
                     NAVBAR
                  ========================== */}

                <section className="Ivs2-navbar">

                    <div className="Ivs2-brand">
                        <div>
                            {
                                step === 1
                                    ?
                                    <img src={require("../../assets/images/loginHelenLabs/TomaDeMuestra/LogoHelenLabs.svg")} alt="helenLogo" style={{ width: "50%" }} />
                                    :
                                    <img
                                        className="b-r-10"
                                        src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                                        style={{ width: "13%", textAlign: "center" }}
                                        alt=""
                                    />
                            }
                        </div>
                    </div>

                    <div className="Ivs2-steps">

                        <div className={`Ivs2-step ${step > 1 ? "done" : step === 1 ? "active" : ""}`}>
                            <span>{step > 1 ? "✓" : "1"}</span> Ticket
                        </div>

                        <div className={`Ivs2-step ${step > 2 ? "done" : step === 2 ? "active" : ""}`}>
                            <span>{step > 2 ? "✓" : "2"}</span> Fiscal
                        </div>

                        <div className={`Ivs2-step ${step === 3 ? "active" : ""}`}>
                            <span>3</span> Finalizar
                        </div>

                    </div>

                </section>

                {/* ==========================
                     STEP 1
                  ========================== */}

                {step === 1 && (
                    <main className="Ivs2-content">

                        <div className="Ivs2-card">
                            <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                <img
                                    className="b-r-10"
                                    src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                                    style={{ width: "20%", textAlign: "center" }}
                                    alt=""
                                />
                            </Col> <br /><br />


                            <div className="Ivs2-center">

                                <h3>FACTURACIÓN ELECTRÓNICA</h3>

                                <p>
                                    Localice el NIM y su clave de acceso en el recibo de pago para validación.
                                </p>

                            </div>

                            <div className="Ivs2-grid-2">

                                <div className="Ivs2-field" style={{ position: "relative" }}>
                                    <label>NIM (PACIENTE)</label>

                                    <input
                                        value={formSelfBiling?.nim}
                                        onChange={(e) => handleChangeForm("nim", e?.target?.value)}
                                        placeholder="👤 Ej. 1012603300064"
                                        className={validations.nim_valid ? "Ivs2-input-error" : ""}
                                    />

                                    {loadingValidation && (
                                        <>
                                            <div className="Ivs2-loader-overlay"></div>

                                            <div className="Ivs2-loader-box">
                                                <div className="Ivs2-loader-circle"></div>
                                                <div className="Ivs2-loader-line"></div>
                                                <span>{loadingText}</span>
                                            </div>
                                        </>
                                    )}

                                    {validations.nim_valid && (
                                        <small className="Ivs2-text-error">
                                            {!formSelfBiling?.nim || formSelfBiling?.nim.trim() === ""
                                                ? "El NIM es obligatorio"
                                                : "El NIM debe contener 13 números"}
                                        </small>
                                    )}
                                </div>

                                <div className="Ivs2-field">
                                    <label>CONTRASEÑA</label>

                                    <div className="Ivs2-password-wrap">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            value={formSelfBiling?.password}
                                            onChange={(e) => handleChangeForm("password", e?.target?.value)}
                                            placeholder="🔑 ••••••••"
                                            className={validations.password_valid ? "Ivs2-input-error" : ""}

                                        />

                                        <button
                                            type="button"
                                            className="Ivs2-eye-btn"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={`pi ${showPassword ? "pi-eye-slash" : "pi-eye"}`} />
                                        </button>

                                        {validations.password_valid && (
                                            <small className="Ivs2-text-error">La contraseña es obligatoria</small>
                                        )}
                                    </div>
                                </div>

                                <div className="Ivs2-field">
                                    <label>FECHA DE ATENCIÓN</label>

                                    <Calendar
                                        value={parseDate(formSelfBiling?.date)}
                                        onChange={(e) => handleChangeForm("date", e?.value)}
                                        dateFormat="dd/mm/yy"
                                        locale="es"
                                        showIcon
                                        placeholder="dd/mm/aaaa"
                                        className={validations.date_valid ? "Ivs2-calendar-error" : "Ivs2-calendar"}
                                        panelClassName="Ivs2-calendar-panel"

                                    />

                                    {validations.date_valid && (
                                        <small className="Ivs2-text-error">
                                            {!formSelfBiling?.date
                                                ? "Selecciona una fecha"
                                                : "La fecha no puede ser mayor al día de hoy"}
                                        </small>
                                    )}
                                </div>

                                <div className="Ivs2-field">
                                    <label>MONTO TOTAL</label>

                                    <input
                                        type='number'
                                        value={formSelfBiling?.amount}
                                        onChange={(e) => {
                                            const value = e?.target?.value;

                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleChangeForm("amount", value);
                                            }
                                        }}
                                        placeholder="💳 0.00"
                                        className={`Ivs2-money-input ${validations.amount_valid ? "Ivs2-input-error" : ""
                                            }`}
                                    />

                                    {validations.amount_valid && (
                                        <small className="Ivs2-text-error">
                                            Ingresa un monto válido
                                        </small>
                                    )}
                                </div>

                            </div>

                            <button
                                className="Ivs2-btn"
                                onClick={() => saveStep1()}
                                disabled={step === 2 ? true : false}
                                style={step === 2 ? { filter: " contrast(0.5)" } : {}}
                            >
                                INGRESAR AL PORTAL     &nbsp;&nbsp;  <i className="pi pi-arrow-right"></i>
                            </button>


                        </div>

                    </main>
                )}
                {/* ==========================
                     STEP 2
                  ========================== */}

                {step === 2 && (
                    <main className="Ivs2-content">
                        {loadingInvoice && (
                            <>
                                <div className="Ivs2-loader-overlay"></div>

                                <div className="Ivs2-loader-box">

                                    <div className="Ivs2-loader-circle"></div>

                                    <div className="Ivs2-loader-line"></div>

                                    <span>{loadingInvoiceText}</span>

                                </div>
                            </>
                        )}


                        <div className="Ivs2-card">

                            <div className="Ivs2-head">

                                <div className="Ivs2-header-fiscal">
                                    <h2 className="Ivs2-header-fiscal-title">Datos Fiscales</h2>

                                    <p className="Ivs2-header-fiscal-nim">
                                        REGISTRO PARA NIM: {formSelfBiling.nim}
                                    </p>
                                </div>
                            </div>

                            <div className="Ivs2-grid-2">
                                <div className="Ivs2-field">
                                    <label>RFC</label>

                                    <input
                                        name="rfc_patient"
                                        placeholder="RFC DEL CONTRIBUYENTE"
                                        value={formSelfBiling.receptor_information?.rfc}
                                        onChange={handleChangeInputEditPatient}
                                        className={validationsPatient.rfc_patient_valid ? "Ivs2-input-error" : ""}
                                    />

                                    {validationsPatient.rfc_patient_valid && (
                                        <small className="Ivs2-text-error">
                                            RFC inválido
                                        </small>
                                    )}
                                </div>

                                <div className="Ivs2-field">
                                    <label>RAZÓN SOCIAL</label>

                                    <input
                                        name="business_name_patient"
                                        value={formSelfBiling.receptor_information?.name_commercial_line}
                                        onChange={handleChangeInputEditPatient}
                                        placeholder="Nombre completo o Empresa"
                                        className={validationsPatient.business_name_patient_valid ? "Ivs2-input-error" : ""}
                                    />

                                    {validationsPatient.business_name_patient_valid && (
                                        <small className="Ivs2-text-error">
                                            La razón social es obligatoria
                                        </small>
                                    )}
                                </div>

                            </div>
                            <div className="Ivs2-grid-2">
                                {loadingValidation && (
                                    <>
                                        <div className="Ivs2-loader-overlay"></div>

                                        <div className="Ivs2-loader-box">
                                            <div className="Ivs2-loader-circle"></div>
                                            <div className="Ivs2-loader-line"></div>
                                            <span>{loadingText}</span>
                                        </div>
                                    </>
                                )}



                                <div className="Ivs2-field">
                                    <label>TIPO DE PERSONA</label>

                                    <select
                                        name="type_person_patient"
                                        value={
                                            formSelfBiling.receptor_information?.type_person === "FISICA"
                                                ? "1"
                                                : formSelfBiling.receptor_information?.type_person === "MORAL"
                                                    ? "2"
                                                    : "0"
                                        }
                                        onChange={handleChangeInputEditPatient}
                                    >
                                        <option value="0">Selecciona una opción</option>
                                        <option value="1">Física</option>
                                        <option value="2">Moral</option>
                                    </select>
                                </div>


                                <div className="Ivs2-field">
                                    <label>C.P. FISCAL</label>

                                    <input
                                        name="cp_patient"
                                        value={formSelfBiling.receptor_information?.expedition_place}
                                        onChange={handleChangeInputEditPatient}
                                        className={validationsPatient.cp_patient_valid ? "Ivs2-input-error" : ""}
                                    />

                                    {validationsPatient.cp_patient_valid && (
                                        <small className="Ivs2-text-error">
                                            Código postal inválido
                                        </small>
                                    )}
                                </div>


                            </div>
                            <div className="Ivs2-grid-2"  >
                                <div className="Ivs2-field">
                                    <label>REGIMEN FISCAL</label>

                                    <select
                                        name="id_tax_regime_patient"
                                        value={formSelfBiling.receptor_information?.tax_regime_id}
                                        onChange={handleChangeInputEditPatient}
                                        className={validationsPatient.id_tax_regime_patient_valid ? "Ivs2-input-error" : ""}
                                    >
                                        <option value={0}>Selecciona una opción</option>

                                        {listTaxRegimes.map(tax => (
                                            <option
                                                key={tax.id_tax_regime}
                                                value={tax.id_tax_regime}
                                            >
                                                {tax.name}
                                            </option>
                                        ))}
                                    </select>

                                    {validationsPatient.id_tax_regime_patient_valid && (
                                        <small className="Ivs2-text-error">
                                            Selecciona un régimen fiscal
                                        </small>
                                    )}
                                </div>

                                <div className="Ivs2-field">
                                    <label>USO DE CFDI</label>

                                    <select
                                        name="id_use_cdfi"
                                        value={formSelfBiling.receptor_information?.id_use_cdfi}
                                        onChange={handleChangeInputEditPatient}
                                        className={validationsPatient.id_use_cdfi_valid ? "Ivs2-input-error" : ""}
                                    >
                                        <option value={0}>Selecciona una opción</option>

                                        {listUseCFDI.map(tax => (
                                            <option
                                                key={tax.id_use_cdfi}
                                                value={tax.id_use_cdfi}
                                            >
                                                {tax.name}
                                            </option>
                                        ))}
                                    </select>

                                    {validationsPatient.id_use_cdfi_valid && (
                                        <small className="Ivs2-text-error">
                                            Selecciona un uso de cdfi
                                        </small>
                                    )}

                                </div>

                            </div>




                            <div className="Ivs2-email-check">

                                <input
                                    type="checkbox"
                                    checked={formSelfBiling.sendEmail}
                                    onChange={() =>
                                        handleChangeForm("sendEmail", !formSelfBiling.sendEmail)
                                    }
                                />

                                <span>ENVIAR FACTURA POR EMAIL</span>

                            </div>

                            <div className="Ivs2-field">
                                <input
                                    name="email_patient"
                                    value={formSelfBiling.receptor_information?.email}
                                    onChange={handleChangeInputEditPatient}
                                    placeholder="correo@ejemplo.com"
                                    className={validationsPatient.email_valid ? "Ivs2-input-error" : ""}
                                />

                                {validationsPatient.email_valid && (
                                    <small className="Ivs2-text-error">
                                        Correo inválido
                                    </small>
                                )}
                            </div>


                            <button
                                className="Ivs2-btn"
                                onClick={() => verifyData()}
                                disabled={isStampInvoice}
                            >
                                GENERAR FACTURA
                            </button>

                        </div>

                    </main>
                )}

                {/* ==========================
                     STEP 3
                  ========================== */}

                {step === 3 && (
                    <main className="Ivs2-content">

                        <div className="Ivs2-card">

                            <div className="Ivs2-success-box">

                                <div className="Ivs2-success-icon">
                                    ✓
                                </div>

                                <h2>¡Factura Lista!</h2>

                                <p>
                                    Los archivos han sido enviados con éxito.
                                </p>

                                <div className="Ivs2-downloads">

                                    <button disabled={loadingDownload} className="Ivs2-dark-btn" onClick={() => handleDownloadInvoice()}  >
                                        {
                                            loadingDownload ? "Descargando pdf" : "PDF"
                                        }

                                    </button>

                                    <button disabled={loadingXml} className="Ivs2-btn-small" onClick={() => handleDownloadXml()}  >
                                        {
                                            loadingXml ? "Descargando XML" : "XML"
                                        }
                                    </button>
                                </div>

                            </div>
                            <div className="Ivs2-grid-2">

                                <div className="Ivs2-box-info">
                                    <label>FOLIO INTERNO</label>
                                    <strong>{formSelfBiling.folio_stamp} </strong>
                                </div>

                                <div className="Ivs2-box-info">
                                    <label>MONTO DE OPERACIÓN</label>
                                    <strong>{formSelfBiling.amount}  </strong>
                                </div>

                            </div>


                            <button
                                className="Ivs2-link-btn"
                                onClick={() =>
                                    resetInvoiceFlow(
                                        "",
                                        false
                                    )
                                }
                            >
                                FACTURAR OTRO COMPROBANTE
                            </button>

                        </div>

                    </main>
                )}

                {/* ==========================
                     FOOTER
                  ========================== */}


            </div>

            {
                // * CONFIGURATION
            }

            {
                showTicketAlert && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(8,15,30,.38)",
                            backdropFilter: "blur(3px)",
                            zIndex: 999999,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "25px",
                            overflowY: "auto"
                        }}
                    >
                        <div
                            style={{
                                width: "760px",
                                maxWidth: "95vw",
                                maxHeight: "95vh",
                                borderRadius: "28px",
                                overflow: "hidden",
                                background: "#ffffff",
                                boxShadow: "0 35px 90px rgba(0,0,0,.28)",
                                animation: "fadeInScale .25s ease",

                                // 👇 importante
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >

                            {/* HEADER */}
                            <div
                                style={{
                                    background:
                                        "linear-gradient(135deg,#2f67e8 0%,#1f4fc9 100%)",
                                    padding: "18px 34px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "18px",
                                    flexShrink: 0
                                }}
                            >
                                <div
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        minWidth: "42px",
                                        borderRadius: "50%",
                                        background: "rgba(255,255,255,.16)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <i
                                        className="pi pi-info-circle"
                                        style={{
                                            color: "#fff",
                                            fontSize: "1.5rem"
                                        }}
                                    ></i>
                                </div>

                                <div>
                                    <div
                                        style={{
                                            color: "#fff",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            lineHeight: 1.1
                                        }}
                                    >
                                        Atención
                                    </div>

                                    <div
                                        style={{
                                            color: "rgba(255,255,255,.92)",
                                            fontSize: "12px",
                                            marginTop: "6px"
                                        }}
                                    >
                                        No se validó correctamente
                                    </div>
                                </div>
                            </div>

                            {/* BODY CON SCROLL */}
                            <div
                                style={{
                                    padding: "38px 34px",
                                    textAlign: "center",

                                    // 👇 aquí está el scroll
                                    overflowY: "auto",
                                    flex: 1,
                                    minHeight: 0
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "14px",
                                        color: "#4a5670",
                                        lineHeight: "1.6",
                                        fontWeight: 500,
                                        wordBreak: "break-word"
                                    }}
                                >
                                    {ticketMessage}
                                </div>

                                <div style={{ marginTop: "32px" }}>
                                    <Button
                                        label="Aceptar"
                                        onClick={() => setShowTicketAlert(false)}
                                        style={{
                                            background: "#2f67e8",
                                            border: "none",
                                            padding: "10px 30px",
                                            fontSize: "14px",
                                            borderRadius: "14px"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                // * CONFIGURATION ALERT SUCCESS
            }

            {
                showSuccessAlert && (
                    <div
                        style={{
                            position: "fixed",
                            top: "105px",
                            right: "24px",
                            zIndex: 999999,
                            animation: "fadeInRight .25s ease"
                        }}
                    >
                        <div
                            style={{
                                width: "355px",
                                borderRadius: "18px",
                                background: "#ffffff",
                                border: "1px solid #e7eef8",
                                boxShadow: "0 22px 55px rgba(0,41,64,.16)",
                                overflow: "hidden"
                            }}
                        >
                            <div
                                style={{
                                    height: "4px",
                                    background:
                                        "linear-gradient(90deg,#2f67e8 0%,#4f8cff 100%)"
                                }}
                            />

                            <div
                                style={{
                                    padding: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "14px"
                                }}
                            >
                                {/* ICONO */}
                                <div
                                    style={{
                                        width: "48px",
                                        height: "48px",
                                        minWidth: "48px",
                                        borderRadius: "14px",
                                        background:
                                            "linear-gradient(135deg,#2f67e8 0%,#4f8cff 100%)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        boxShadow:
                                            "0 10px 22px rgba(47,103,232,.22)"
                                    }}
                                >
                                    <i
                                        className="pi pi-check"
                                        style={{
                                            color: "#fff",
                                            fontSize: "1.05rem",
                                            fontWeight: 700
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontWeight: 700,
                                            fontSize: "17px",
                                            color: "#183153"
                                        }}
                                    >
                                        Acceso Correcto
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "13px",
                                            color: "#73819c",
                                            marginTop: "3px"
                                        }}
                                    >
                                        Validación completada exitosamente
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                // * CONFIGURATION ALERTS PDF AND XML
            }
            {
                showDownloadAlert && (
                    <div
                        style={{
                            position: "fixed",
                            top: "105px",
                            right: "24px",
                            zIndex: 999999,
                            animation: "fadeInRight .25s ease"
                        }}
                    >
                        <div
                            style={{
                                width: "355px",
                                borderRadius: "18px",
                                background: "#ffffff",
                                border: "1px solid #e7eef8",
                                boxShadow: "0 22px 55px rgba(0,41,64,.16)",
                                overflow: "hidden"
                            }}
                        >
                            <div
                                style={{
                                    height: "4px",
                                    background:
                                        "linear-gradient(90deg,#2f67e8 0%,#4f8cff 100%)"
                                }}
                            />

                            <div
                                style={{
                                    padding: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "14px"
                                }}
                            >
                                <div
                                    style={{
                                        width: "48px",
                                        height: "48px",
                                        minWidth: "48px",
                                        borderRadius: "14px",
                                        background:
                                            "linear-gradient(135deg,#2f67e8 0%,#4f8cff 100%)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        boxShadow:
                                            "0 10px 22px rgba(47,103,232,.22)"
                                    }}
                                >
                                    <i
                                        className="pi pi-check"
                                        style={{
                                            color: "#fff",
                                            fontSize: "1.05rem",
                                            fontWeight: 700
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontWeight: 700,
                                            fontSize: "17px",
                                            color: "#183153"
                                        }}
                                    >
                                        Descarga completada
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "13px",
                                            color: "#73819c",
                                            marginTop: "3px"
                                        }}
                                    >
                                        {tittlePdf}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >

    )
}

